var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot p-pl-2 p-mb-3"},[_vm._v(" Copyright © 2021 bogorpools.com Corporation, All Right Reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }